import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  statusFilter,
  setStatusFilter,
  applyFilters,
  removeFilters,
  hubFilter,
  setHubFilter,
  clientFilter,
  setClientFilter,
  deliveryDateFilter,
  setDeliveryDateFilter,
  apidata,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Status Filter */}
          <Form.Group controlId="statusFilter">
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">Order Status</option>
              <option value="Pending">Pending</option>
              <option value="Delivered">Delivered</option>
              <option value="Cancelled">Cancelled</option>
            </Form.Control>
          </Form.Group>

          {/* Hub Filter */}
          <Form.Group controlId="hubFilter">
            <Form.Label>Hubs</Form.Label>
            <Form.Control
              as="select"
              value={hubFilter || ""}
              onChange={(e) => setHubFilter(e.target.value)}
            >
              <option value="">All Hubs</option>
              {apidata &&
                Array.from(
                  new Set(
                    apidata.map((item) =>
                      item.hub_id && item.hub_id.name ? item.hub_id.name : null
                    )
                  )
                )
                  .filter(Boolean)
                  .map((name, index) => (
                    <option key={index} value={name}>
                      {name}
                    </option>
                  ))}
            </Form.Control>
          </Form.Group>

          {/* Client Filter */}
          <Form.Group controlId="clientFilter">
            <Form.Label>Clients</Form.Label>
            <Form.Control
              as="select"
              value={clientFilter || ""}
              onChange={(e) => setClientFilter(e.target.value)}
            >
              <option value="">All Clients</option>
              {apidata &&
                Array.from(
                  new Set(
                    apidata.map((item) =>
                      item.client_id && item.client_id.name
                        ? item.client_id.name
                        : null
                    )
                  )
                )
                  .filter(Boolean)
                  .map((name, index) => (
                    <option key={index} value={name}>
                      {name}
                    </option>
                  ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="deliveryDateFilter">
            <Form.Label>Delivery Date</Form.Label>
            <Form.Control
              type="date"
              value={deliveryDateFilter || ""}
              onChange={(e) => setDeliveryDateFilter(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
